import { InventoryTransferStatus } from './enums';

export class InventoryTransferSearchFilter {
    Status: InventoryTransferStatus = null;
    FromDate: Date = null;
    ToDate: Date = null;
    Query: string = '';
}
